import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Dropdown, Icon} from 'semantic-ui-react';
import moment from 'moment';
import {colors} from '../../../../common/constants/colors';
import BarChart from './chart/bar';
import LineChart from './chart/line';

const typesOfGraphics = [
  {'name': 'Líneas', 'value': 'line'},
  {'name': 'Barras', 'value': 'bar'},
];

class LineSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'typeOfGraphicTmp': typesOfGraphics[0].value,
      'typeOfGraphicSelected': typesOfGraphics[0].value,
      'showSalesData': true,
      'showBudgetData': true,
    };
  }

  dataByDealer() {
    const {data} = this.props;
    const sales = this.groupDataByMonthAndYear(data.sales, 'Ventas');
    const budgets = this.groupDataByMonthAndYear(data.budgets, 'Presupuesto');
    return this.mergeArraysElements(sales, budgets);
  }

  groupDataByMonthAndYear(list, type) {
    return list.map((item) => {
      const formattedMonth = moment().month(item.month - 1).format('MM');
      const formattedYear = moment().year(item.year).format('YY');

      const data = {
        'name': `${formattedMonth}-${formattedYear}`,
      };
      data[type] = item.amount;

      return data;
    });
  }

  mergeArraysElements(array1, array2) {
    return array1.map((obj, i) => ({...obj, ...array2[i]}));
  }

  getTypesOfGraphics() {
    return typesOfGraphics.map((element) => {
      return {'text': element.name, 'value': element.value};
    });
  }

  changeTypeOfGraphic(value) {
    this.setState({'typeOfGraphicTmp': value}, () => this.updateDataForTypeOfGraphic());
  }

  updateDataForTypeOfGraphic() {
    const {typeOfGraphicSelected, typeOfGraphicTmp} = this.state;
    if (typeOfGraphicSelected === typeOfGraphicTmp) {
      return;
    }
    this.setState({
      'typeOfGraphicSelected': typeOfGraphicTmp,
    });
  }

  setCheckedData() {
    const {showSalesData, showBudgetData} = this.state;
    const divStyleForSale = {
      'color': colors[0],
    };
    const divStyleForBudget = {
      'color': colors[1],
    };

    return (
      <div>
        <div onClick={() => this.onShowOrHideDataChange('sale')} className={showSalesData ? '' : 'disabled'}>
          <span style={divStyleForSale}><Icon name='stop' size='big' /></span>
          Ventas
        </div>
        <div onClick={() => this.onShowOrHideDataChange('budget')} className={showBudgetData ? '' : 'disabled'}>
          <span style={divStyleForBudget}><Icon name='stop' size='big' /></span>
          Presupuesto
        </div>
      </div>
    );
  }

  onShowOrHideDataChange(type) {
    const {showSalesData, showBudgetData} = this.state;
    if (type === 'sale') {
      this.setState({'showSalesData': !showSalesData});
      return;
    }
    this.setState({'showBudgetData': !showBudgetData});
  }

  renderChartSection(dataFormatted) {
    const {typeOfGraphicSelected, showSalesData, showBudgetData} = this.state;
    if (!dataFormatted || !dataFormatted.length) {
      return <div className='without-data'>No hay datos para generar el gráfico</div>;
    }

    switch (typeOfGraphicSelected) {
      default:
      case 'bar':
        return <BarChart data={dataFormatted} showSalesData={showSalesData} showBudgetData={showBudgetData} />;
      case 'line':
        return <LineChart data={dataFormatted} showSalesData={showSalesData} showBudgetData={showBudgetData} />;
    }
  }

  render() {
    const {typeOfGraphicTmp} = this.state;
    const dataFormatted = this.dataByDealer();

    if (!dataFormatted.length) {
      return null;
    }

    return (
      <Card raised fluid className='chart-container'>
        <div className='title-bar'>
          <div className='filters-section'>
            <Grid textAlign='left'>
              <Grid.Row>
                <Grid.Column>
                  <h2>{this.props.data.dealerName.toUpperCase()}</h2>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={2}>
                  <h4>Tipo Gráfico</h4>
                </Grid.Column>
                <Grid.Column width={2}>
                  <Dropdown selection
                    options={this.getTypesOfGraphics()}
                    search
                    value={typeOfGraphicTmp}
                    onChange={(e, {value}) => this.changeTypeOfGraphic(value)}
                    placeholder='Tipo de gráfico'
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </div>

        <div className='check-section'>
          {this.setCheckedData()}
        </div>
        {this.renderChartSection(dataFormatted)}

      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'salesVsBudgets': state.sales.salesVsBudgets,
  };
};

export default connect(mapStateToProps, {
})(LineSection);
